import React from 'react'
import { Link } from "react-router-dom";

const EnergyEfficientBuilding = () => {
  return (
    <>


      <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
        <div className="container">
          <h2 className="breadcrumb-title">Energy Efficient Building</h2>
          <ul className="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li className="active"><b>Energy Efficient Building</b></li>
          </ul>
        </div>
      </div>
      <div className="service-single py-120" style={{ marginTop: "-80px" }}>
        <div className="container">
          <div className="service-single-wrap">
            <div className="row">

              <div className="col-xl-4 col-lg-4">
                <div className="service-sidebar">
                  <div className="widget">
                    <h4 className="title">All Services</h4>
                    <div className="category">
                      <Link to="/energy-efficient-building"><i className="far fa-angle-double-right" /><b>Energy Efficient Building</b></Link>
                      <Link to="/hybrid-solar-power-plant"><i className="far fa-angle-double-right" /><b>Hybrid Solar Power Plant</b></Link>
                      <Link to="/on-grid-off-grid-solar"><i className="far fa-angle-double-right" /><b>On-Grid & Off-Grid Solar</b></Link>
                      <Link to="/EV-charging-solution"><i className="far fa-angle-double-right" /><b>EV Charging Solution</b></Link>
                      <Link to="/solar-water-heater-solution"><i className="far fa-angle-double-right" /><b>Solar Water Heater Solution</b></Link>
                      <Link to="/solar-water-pump-solution"><i className="far fa-angle-double-right" /><b>Solar Water Pump Solution</b></Link>
                      <Link to="/solar-electrical-installation"><i className="far fa-angle-double-right" /><b>Solar & Electrical Installation</b></Link>
                    </div>
                  </div>
                  {/* <div className="widget">
                    <h4 className="title">Download</h4>
                    <div className="service-download">
                      <a to="#"><i className="far fa-file-pdf" /> Download Brochure</a>
                      <a to="#"><i className="far fa-file-alt" /> Download Application</a>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-xl-8 col-lg-8">
                <div className="service-details">
                  <div className="mb-30">
                    <img src="assets/yog/Energy Efficient Building.webp" alt="thumb" />
                  </div>
                  <div className="content">
                    <h3 className="mb-20">Energy Efficient Building</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      Energy-efficient buildings are designed to use less energy while maintaining comfort, health, and productivity for occupants. These buildings focus on reducing electricity consumption, lowering carbon emissions, and optimizing natural resources.
                    </p>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      An energy-efficient building is a structure that minimizes energy use through smart design, advanced materials, and modern technologies like solar power, insulation, and efficient appliances.
                    </p>
                    <div className="row">
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/01.jpg" alt />
                      </div>
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/02.jpg" alt />
                      </div>
                    </div>
                    <div className="my-4">
                      <div className="mb-3">
                        <h3 className="mb-3">Our Energy Efficient Solutions</h3>
                      </div>
                      <ul className="list">
                        <li><i className="far fa-check-double" />Solar Power Integration:- We install advanced solar panel systems that generate clean and renewable energy, reducing dependency on traditional electricity. </li>
                        <li><i className="far fa-check-double" />Smart Building Design:- Our team ensures proper building orientation, ventilation, and insulation to maximize natural light and airflow.</li>
                        <li><i className="far fa-check-double" />Energy Saving Lighting:- We provide LED lighting solutions and automation systems to reduce unnecessary power consumption.
                        </li>
                        <li><i className="far fa-check-double" />Energy Storage Systems:- Backup solutions like batteries help store excess solar energy for use during peak hours or power outages.</li>
                        <li><i className="far fa-check-double" />Efficient Cooling & Ventilation:- We optimize cooling systems to ensure minimal energy usage while maintaining indoor comfort.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default EnergyEfficientBuilding